export type ItineraryLanguage = "en" | "cn";

export const ITINERARY_TIMELINE_COPY = {
  en: {
    language: "EN",
    activityDetails: "Activity Details",
    hotelDetails: "Hotel Details",
    stayAt: "Stay at",
    or: "or",
    similarClass: "or similar class",
    mealCodeReference: "Meal Code Reference",
    additionalTour: "Compulsory Additional Tour",
    optionalTour: "Optional Tour",
    specialDisclaimer: "Special Disclaimer",
    disclaimer: "Disclaimer",
    disclaimerItems: [
      "All activity and hotel images are for illustration purposes only.",
      "All activities are subject to weather conditions and availability.",
      "All hotels cannot be selected during the booking process, please refer to the arrangements made by the travel agency.",
      "During major conferences, fairs, and festivals, acts of nature and heavy flow of tourist arrival, the sequence of itinerary may change and accommodation may be located in an alternative city without prior notice.",
      "Final sequences of the itinerary is subject to local ground final arrangement.",
      "There will be no refund or replacement if the tour logistic affected by the above issue.",
    ],
  },
  cn: {
    language: "CN",
    activityDetails: "活动详情",
    hotelDetails: "酒店详情",
    stayAt: "入住",
    or: "或",
    similarClass: "或同等级酒店",
    mealCodeReference: "餐食代码",
    additionalTour: "保证附加项目",
    optionalTour: "自费项目",
    specialDisclaimer: "特别免责声明",
    disclaimer: "免责声明",
    disclaimerItems: [
      "所有活动及酒店图片仅供参考。",
      "所有活动均受天气状况及实际供应情况影响。",
      "预订过程中无法指定酒店，请以旅行社最终安排为准。",
      "如遇大型会议、展览、节庆活动、自然灾害或大量游客涌入等情况，行程顺序可能会有所调整，住宿地点亦可能安排在其他城市，恕不另行通知。",
      "最终行程顺序以当地接待方的最终安排为准。",
      "如因上述情况导致行程安排或旅游交通受到影响，恕不退款或更换相关安排。",
    ],
  },
} as const;
